import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabClientDetails from '../../form-fields/tab-client-details/tab-client-details';
class EditViewPostDischargeTabClientDetails extends Component {
  render() {    
    return (
      <div>
        <FormFieldsTabClientDetails 
          {...this.props}
          locked={this.props.locked}
          // referralsourcesList={this.props.referralsourcesList.referralsources}
          referralsourcesList={this.props.referralsourcesList}
        />
      </div>
    );
  }
}
EditViewPostDischargeTabClientDetails.propTypes = {
  /*** fix make required */
  locked: PropTypes.bool,
  /*** fix make required */
  referralsourcesList: PropTypes.array,
}
EditViewPostDischargeTabClientDetails = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabClientDetails);
export default EditViewPostDischargeTabClientDetails;